import { Configuration } from '@contact/upgrade';

const MODULE_NAME = 'mailWorkspaceConfigurationService';

export type MailLayoutOptions = {
  readonly columnMode: boolean;
};

export class MailWorkspaceConfigurationService {
  static $inject: Array<string> = ['configuration'];

  public name = MODULE_NAME;
  private layoutOptions: MailLayoutOptions;

  constructor(protected configuration: Configuration) {
    this.layoutOptions = {
      columnMode: this.configuration.mail && this.configuration.mail.columnMode ? (this.configuration.mail.columnMode as boolean) : false,
    };
  }

  getLayoutOptions(): MailLayoutOptions {
    return this.layoutOptions;
  }
}

export default MODULE_NAME;
